import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

import { LogService } from '../providers';

// Server- and URL-driven i18n keys (e.g. login-unlock-result) must never render the raw,
// potentially attacker-controlled key text in the UI when no translation is found.
@Injectable()
export class NoKeyMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams): string {
    LogService.error(`Missing translation key: "${params.key}"`);
    return '';
  }
}
